import { BreadCrumb } from './BreadCrumb'

export default BreadCrumb
